/* Shared Web Audio engine — ONE AudioContext for the whole app.
   Android WebView allows only a handful of live contexts; creating one per
   tile/click caused late sounds, audio/visual drift and ANR freezes. */

let ctx = null;

export const getAudioCtx = () => {
  if (typeof window === 'undefined') return null;
  if (ctx && ctx.state !== 'closed') {
    if (ctx.state !== 'running') { try { ctx.resume(); } catch (_) { /* noop */ } }
    return ctx;
  }
  const C = window.AudioContext || window.webkitAudioContext;
  if (!C) return null;
  try { ctx = new C({ latencyHint: 'interactive' }); }
  catch (_) { try { ctx = new C(); } catch (__) { ctx = null; } }
  return ctx;
};

/* Run fn(ctx) as soon as the context is actually running, so scheduled
   sounds never pile up while suspended and burst out late. */
export const withAudio = (fn) => {
  const c = getAudioCtx();
  if (!c) return;
  if (c.state === 'running') { fn(c); return; }
  c.resume().then(() => fn(c)).catch(() => {});
};

const unlock = () => {
  const c = getAudioCtx();
  if (!c || c.state === 'running') return;
  try {
    const src = c.createBufferSource();
    src.buffer = c.createBuffer(1, 1, 22050);
    src.connect(c.destination);
    src.start(0);
  } catch (_) { /* noop */ }
};

let installed = false;
export const installAudioUnlock = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  ['pointerdown', 'touchstart', 'keydown'].forEach((ev) =>
    window.addEventListener(ev, unlock, { capture: true, passive: true }));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && ctx && ctx.state !== 'running') {
      try { ctx.resume(); } catch (_) { /* noop */ }
    }
  });
};
